import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=810defac&scoped=true"
import script from "./OrderOverview.vue?vue&type=script&lang=js"
export * from "./OrderOverview.vue?vue&type=script&lang=js"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=810defac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810defac",
  null
  
)

export default component.exports